<template>
  <section class="home-contact" id="location">
    <div class="container">
      <div class="contact-grid">
        <div class="contact-info" data-aos="fade-right" data-aos-duration="1000">
          <span class="section-tag">
            <i class="ri-map-pin-line"></i> Visit Us
          </span>
          <h2>Find <span class="text-accent">Our Location</span></h2>
          <p class="contact-desc">
            Come visit us for a fresh, flavorful halal Mexican dining experience. 
            We're conveniently located in Storrs Mansfield, CT.
          </p>

          <div class="info-cards">
            <div class="info-card">
              <div class="info-icon">
                <i class="ri-map-pin-2-fill"></i>
              </div>
              <div>
                <h4>Address</h4>
                <p>1244 Storrs Rd<br/>Storrs Mansfield, CT 06268</p>
              </div>
            </div>

            <div class="info-card">
              <div class="info-icon">
                <i class="ri-phone-fill"></i>
              </div>
              <div>
                <h4>Phone</h4>
                <a href="tel:+!"></a>
              </div>
            </div>

            <div class="info-card">
              <div class="info-icon">
                <i class="ri-mail-fill"></i>
              </div>
              <div>
                <h4>Email</h4>
                <a href="mailto:info@guacngrill.com">info@guacngrill.com</a>
              </div>
            </div>

            <div class="info-card">
              <div class="info-icon">
                <i class="ri-time-fill"></i>
              </div>
              <div>
                <h4>Hours</h4>
                <p>Mon – Sun: 11:00 AM – 10:00 PM</p>
              </div>
            </div>
          </div>

          <div class="social-links">
            <a href="#" aria-label="Facebook">
              <i class="ri-facebook-fill"></i>
            </a>
            <a href="#" aria-label="Instagram">
              <i class="ri-instagram-fill"></i>
            </a>
            <a href="#" aria-label="Google Maps">
              <i class="ri-google-fill"></i>
            </a>
          </div>
        </div>

        <div class="contact-map" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
          <div class="map-wrapper">
            <div class="map-placeholder">
              <div class="map-placeholder-content">
                <i class="ri-map-pin-2-line"></i>
                <h4>Interactive Map</h4>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeContact",
});
</script>

<style lang="scss" scoped>
.home-contact {
  padding: 120px 0;
  background: linear-gradient(180deg, #0f0f0f 0%, #0a0a0a 100%);

  .contact-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    align-items: center;
  }

  .contact-info {
    .section-tag {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #b5ff00;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 44px;
      font-weight: 800;
      color: #ffffff;
      letter-spacing: -1px;
      margin-bottom: 16px;
      line-height: 1.15;
      .text-accent {
        color: #b5ff00;
      }
    }

    .contact-desc {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.7;
      margin-bottom: 36px;
    }

    .info-cards {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-bottom: 36px;
    }

    .info-card {
      display: flex;
      align-items: flex-start;
      gap: 16px;

      .info-icon {
        width: 44px;
        height: 44px;
        min-width: 44px;
        background: rgba(181, 255, 0, 0.08);
        border: 1px solid rgba(181, 255, 0, 0.12);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 20px;
          color: #b5ff00;
        }
      }

      h4 {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 4px;
      }

      p {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 1.5;
        margin: 0;
      }

      a {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.5);
        text-decoration: none;
        transition: color 0.3s ease;
        &:hover {
          color: #b5ff00;
        }
      }
    }

    .social-links {
      display: flex;
      gap: 12px;

      a {
        width: 44px;
        height: 44px;
        background: rgba(255, 255, 255, 0.06);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        i {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.6);
          transition: color 0.3s ease;
        }
        &:hover {
          background: rgba(181, 255, 0, 0.1);
          border-color: rgba(181, 255, 0, 0.3);
          transform: translateY(-2px);
          i {
            color: #b5ff00;
          }
        }
      }
    }
  }

  .contact-map {
    .map-wrapper {
      width: 100%;
      height: 480px;
      border-radius: 24px;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.08);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .map-placeholder {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        
        .map-placeholder-content {
          text-align: center;
          color: rgba(255, 255, 255, 0.6);
          
          i {
            font-size: 48px;
            color: #b5ff00;
            margin-bottom: 16px;
            display: block;
          }
          
          h4 {
            font-size: 18px;
            font-weight: 600;
            color: #ffffff;
            margin-bottom: 8px;
          }
          
          p {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.4);
            margin: 0;
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .home-contact {
    padding: 80px 0;

    .contact-grid {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .contact-info h2 {
      font-size: 34px;
    }

    .contact-map .map-wrapper {
      height: 350px;
    }
  }
}
</style>
